import React from "react";
import { useSelector } from "react-redux";
import DataDisplay from "../../../../components/dataDisplay/dataDisplay";
import SectionContainer from "../../../../components/sectionContainer/sectionContainer";

const ScheduledCancellations = ({ qa }) => {
  const { displayScheduledCancellations, scheduledCancellationsNumber, url, tooltip } = useSelector(
    (state) => state.membershipUnits.membershipUnits.scheduledCancellations
  );

  return displayScheduledCancellations ? (
    <SectionContainer
      title="Scheduled Cancellations"
      toolTip={tooltip}
      toolTipId="scheduledCancellationsNumber"
      isToolTipHtml
    >
      <DataDisplay
        type="number"
        value={scheduledCancellationsNumber}
        url={url}
        disableAnimation={qa}
        toolTipContent={tooltip}
        toolTipId="scheduledCancellationsNumber"
      />
    </SectionContainer>
  ) : null;
};

export default ScheduledCancellations;
